import { useNavigate } from 'react-router-dom'
import { useExitImpersonation, useMe } from '../lib/auth'

/**
 * Persistent while a super admin is viewing an org. It names the org and the
 * read-only state on every screen, so nobody is ever unsure which hat they're
 * wearing — and Exit is always one click away.
 */
export function ImpersonationBanner() {
  const me = useMe()
  const exit = useExitImpersonation()
  const navigate = useNavigate()
  if (!me.impersonating) return null
  const { orgId, orgName } = me.impersonating

  return (
    <div
      role="status"
      className="sticky top-0 z-30 flex h-10 items-center justify-between gap-4 bg-violet-700 px-4 text-sm text-white shadow"
    >
      <span>
        <span aria-hidden className="mr-1.5">◉</span>
        Viewing <span className="font-semibold">{orgName}</span> as platform admin ·{' '}
        <span className="rounded bg-white/15 px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide">read-only</span>
      </span>
      <button
        // Go to the org's admin page FIRST (allowed while impersonating), then end
        // it. The other order loses the race to the merchant layout's guard, which
        // redirects to /admin/orgs the moment the session has no org.
        onClick={() => {
          navigate(`/admin/orgs/${orgId}`)
          exit.mutate()
        }}
        disabled={exit.isPending}
        className="rounded-md bg-white px-3 py-1 text-xs font-semibold text-violet-800 hover:bg-violet-50 disabled:opacity-60"
      >
        {exit.isPending ? 'Exiting…' : 'Exit'}
      </button>
    </div>
  )
}
